module.exports = __webpack_public_path__ + "img/blake.7c6624ae.svg";